import { AxiosRequestConfig } from 'axios';

import { State } from 'model/State';
import { MACCurrentContactData } from 'modules/mac/duck/models';
import hamsClient from 'modules/hams';
import { selectHamsClientConfig } from 'modules/auth/selectors';

import { baseContactApiUrl, baseNonExternalContactApiUrl } from '../..';
import { getImpersonationHeader } from 'util/mac/helpers';

export const putToHamsClient = async (
  state: State,
  data: MACCurrentContactData,
  params?: AxiosRequestConfig['params'],
) => {
  try {
    const config = selectHamsClientConfig(state);
    const impersonationHeader = getImpersonationHeader(state);

    return (
      await hamsClient.put(`${baseContactApiUrl}`, data, {
        ...config,
        headers: {
          ...config.headers,
          ...impersonationHeader,
        },
        params,
      })
    ).data;
  } catch (error) {
    return Promise.reject(error);
  }
};
export const putToHamsClientNonExternal = async (
  remainingPath: string,
  state: State,
  data?: MACCurrentContactData,
  params?: AxiosRequestConfig['params'],
) => {
  try {
    const config = selectHamsClientConfig(state);
    const impersonationHeader = getImpersonationHeader(state);

    return (
      await hamsClient.put(`${baseNonExternalContactApiUrl}${remainingPath}`, data, {
        ...config,
        headers: {
          ...config.headers,
          ...impersonationHeader,
        },
        params,
      })
    ).data;
  } catch (error) {
    return Promise.reject(error);
  }
};
